import { render, staticRenderFns } from "./SchemaColorConfig.vue?vue&type=template&id=30e3c641"
import script from "./SchemaColorConfig.vue?vue&type=script&lang=js"
export * from "./SchemaColorConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports